
<div class="container-fluid p-2 main">
  <nav class="navbar navbar-inverse  navbar-static-top navbar-expand-lg navbar-dark bg-primary fixed-top">
    <div class="navbar-brand navbar-header">Sakshi Bhardwaj</div>
    <button class="navbar-toggler collapsed ml-auto float-sm-right"type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
   
    <div class=" collapse navbar-collapse" id="navbarTogglerDemo01">
      
      
      <ul class=" nav navbar-nav ml-auto mt-2 mt-lg-0">
        <li class="nav-item ">
          <a class="nav-link"  routerLink="/aboutme" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            About Me <span class="sr-only">(current)</span></a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" routerLink="/publications" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            Research</a>
        </li> -->
        <li class="nav-item">
          
              <a class="nav-link" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show" (click)="openCV()">
                CV
              </a>
        </li>
        <!-- <li class="nav-item">
          
          <a class="nav-link" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show" (click)="openResume()">
            Resume
          </a>
     
      
    </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link " routerLink="/cv" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            Timeline</a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link " routerLink="/publications" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            Research</a>
        </li>

        <li class="nav-item">
          <a class="nav-link " routerLink="/teaching" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            Teaching</a>
        </li>

        <li class="nav-item">
          <a class="nav-link " routerLink="/news" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
            News</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link " routerLink="/blog" routerLinkActive="active">Blog</a>
        </li> -->
      </ul>
      
    </div>

    
    
    
  </nav>
<div class="main-content">
  <div class="row">
    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 d-none d-lg-block " style="background-color:rgb(236, 243, 245)">
      <div class="mt-xs-5 p-4 mt-5 side-profile">
        <app-profile></app-profile>
        
      </div>
    </div>

    <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12 p-xs-2">
      <div class="mt-xs-5  mt-5  p-2">
        
        <router-outlet></router-outlet>
      </div>
      
    </div>
  </div>

 
  
  <footer class="footer">
    <div class=" d-block d-lg-none" *ngIf="!router.url.includes('aboutme')">
      <app-h-profile></app-h-profile>
    </div>
    
    <div class="text-center p-3 mb-sm-1 mb-1" style="background-color: rgba(0, 0, 0, 1);">
      <span class="text-light">
        © 2020 Copyright:
      </span>
      <a class="text-light" href="https://sakshib2.com/">Sakshi Bhardwaj</a>
    </div>
    
    
  </footer>
</div>


</div>

